import styled from 'styled-components'

const SupportUsStyle = styled.div.attrs()`
	--filmsWrappMarg: 8.5%;
	--titleMinMarg: var(--sp4x);

	.SupportTopSection {
		margin: 0 var(--filmsWrappMarg);

		.Title {
			min-width: 46%;
			margin-bottom: var(--titleMarg);
		}

		.filmsWrapp {
			margin-bottom: var(--titleMarg);
		}

		.singleTitle {
			max-width: var(--sp128x);
		}
	}

	.contactSection {
		.titleContactSection  {
			margin-bottom: var(--titleMinMarg);
			max-width: var(--sp90x);
		}
		.description {
			max-width: var(--sp90x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--filmsWrappMarg: 7%;
		--titleMinMarg: var(--sp3x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--filmsWrappMarg: 9%;
		--titleMinMarg: var(--sp3x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeXS}) {
		--filmsWrappMarg: 8%;
		--titleMinMarg: var(--sp3x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) {
		--titleMinMarg: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--filmsWrappMarg: 3%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--filmsWrappMarg: 5%;
	}
`
export default SupportUsStyle
